import React from 'react';
import { connect } from 'react-redux';
import FormTab from '../../../core/form/components/FormTab';
import FormBase from '../../../core/form/components/FormBase';
import PageTitle from '../../../core/form/components/PageTitle';

import { Nav, TabContent, TabPane } from 'reactstrap';

class Reports extends FormBase {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: null,
      activeTab: '1',
    };

    this.toggleTab = this.toggleTab.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  toggleTab(tab, tag) {
    this.setState({ activeTab: tab });

    switch (tag) {
      default:
        break;
    }
  }

  goBack() {
    this.props.history.goBack();
  }

  render() {
    const { activeTab } = this.state;

    const title = 'Profit Probe Business Analysis';
    const description = '';

    return (
      <div className="p-0 h-100">
        <PageTitle title={title} description={description} />
        <Nav tabs className="mt-2">
          <FormTab
            caption="Business Overview"
            tabId="1"
            activeTab={activeTab}
            toggle={this.toggleTab}
            tabTag="overview"
          />
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="1" className="mb-2 p-1">
            todo
          </TabPane>
        </TabContent>
      </div>
    );
  }
}

const mapStoreToProps = (store) => {
  return {
    realm: store.realm,
  };
};

export default connect(mapStoreToProps)(Reports);
